import styles from './ListItemFee.module.css';

interface FeeItem {
  name: string;
  price: number;
}

interface ListItemFeeProps {
  item: FeeItem;
}

export function ListItemFee({ item }: ListItemFeeProps) {
  return (
    <div className={styles.container}>
      <span className={styles.name}>{item.name}</span>
      <span className={styles.price}>${(item.price / 100).toFixed(2)}</span>
    </div>
  );
}

export default ListItemFee;
